import { motion } from 'framer-motion'
import Newwabout from '../../../assets/images/homepage/homepagebg.webp'
import EarthImage from '../../../assets/images/aboutuspage/earth_image.webp'
import CommonHeroSection from '../commonherosection/CommonHeroSection'

type AboutUsHeroSectionProps = {
  header?: React.ReactNode
}

const AboutUsHeroSection = ({ header }: AboutUsHeroSectionProps) => {
  return (
    <CommonHeroSection
      wrapperClassName="relative min-h-[60vh]  md:min-h-[75vh] w-full overflow-hidden"
      contentClassName="relative z-20 flex min-h-[60vh]  md:min-h-[75vh] w-full flex-col"
      backgroundImage={Newwabout}
      backgroundAlt="About us background"
    >
      <div className="relative z-10 flex min-h-[60vh] md:min-h-[75vh] flex-col overflow-hidden">
        <div className="shrink-0">{header}</div>

        {/* Rotating Earth Background */}
        <motion.img
          src={EarthImage}
          alt="Earth"
          animate={{ rotate: 360 }}
          transition={{
            duration: 80,
            repeat: Infinity,
            ease: 'linear',
          }}
          className="
            pointer-events-none
            absolute left-1/2 top-1/2
            z-0
            w-[280px] sm:w-[380px] md:w-[520px] lg:w-[650px] xl:w-[800px]
            -translate-x-1/2 -translate-y-1/2
            opacity-40
          "
        />

        <div className="relative z-10 flex grow items-center justify-center px-4 sm:px-6 md:px-10 lg:px-16">
          <h1 
            className="
              text-center text-white font-rajdhani font-semibold
              text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl
              leading-tight
              w-full max-w-[90%] sm:max-w-2xl md:max-w-3xl lg:max-w-5xl xl:max-w-6xl
            "
          >
            We Do Not Just Build Software.
            <br className="hidden sm:block" />
            We Engineer Certainty.
          </h1>
        </div>
      </div>
    </CommonHeroSection>
  )
}

export default AboutUsHeroSection